/**
 * User: Joe Forzano
 * Date: January 7th, 2015
 */

"use strict";

// ---------------------------------------------------
// Load Super Class

var SoaModel = require('bunsen/models/SoaModel');
var Carrier = require('../logistics/Carrier');
var Backbone = require('dibs-backbone');


// ---------------------------------------------------
// Module Definition

var ShipmentTracking = module.exports = SoaModel.extend();


// ---------------------------------------------------
// Dependencies

var _ = require('underscore');


// ---------------------------------------------------
// Local Vars


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShipmentTracking.prototype, {
    defaults: {
        trackingNumber : '',
        carrier: {}
    },

    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'carrier',
                relatedModel: Carrier
            }
        ]);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/ShipmentTracking.js
// module id = 180
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56